import dayjs from "dayjs";
import "dayjs/locale/tr";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);
dayjs.locale("tr");

export const fmtDate = (d) => (d ? dayjs(d).format("DD.MM.YYYY") : "-");
export const fmtDateTime = (d) => (d ? dayjs(d).format("DD.MM.YYYY HH:mm") : "-");
export const fmtTime = (d) => (d ? dayjs(d).format("HH:mm") : "-");
export const fromNow = (d) => (d ? dayjs(d).fromNow() : "");

export const fmtCurrency = (n, cur = "TRY") =>
  new Intl.NumberFormat("tr-TR", { style: "currency", currency: cur, maximumFractionDigits: 0 }).format(n || 0);

export const fmtNumber = (n) => new Intl.NumberFormat("tr-TR").format(n || 0);

export const minutesToHours = (m) => {
  const h = Math.floor((m || 0) / 60);
  const mm = (m || 0) % 60;
  return `${h}s ${mm}dk`;
};

export const initials = (name) =>
  (name || "?").split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();

export const hexToHslString = (hex) => {
  if (!hex) return null;
  let h = hex.replace("#", "").trim();
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  if (h.length !== 6 || /[^0-9a-fA-F]/.test(h)) return null;
  const r = parseInt(h.slice(0, 2), 16) / 255;
  const g = parseInt(h.slice(2, 4), 16) / 255;
  const b = parseInt(h.slice(4, 6), 16) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let hue = 0, s = 0; const l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: hue = (g - b) / d + (g < b ? 6 : 0); break;
      case g: hue = (b - r) / d + 2; break;
      default: hue = (r - g) / d + 4;
    }
    hue /= 6;
  }
  return `${Math.round(hue * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
};

export const isOverdue = (dueDate, status) => {
  if (!dueDate || ["completed", "cancelled"].includes(status)) return false;
  return dayjs(dueDate).isBefore(dayjs(), "day");
};
